import {
  SET_DEVICE,
  // TODO: import action types added later
} from './types'

function setDevice(device) {
  return {
    type: SET_DEVICE,
    payload: {
      device,
    },
  }
}
// TODO: add more action creators

export {
  setDevice,
  // TODO: export action creators added later
}
